import { _ as BaseH6Plugin, a as BaseSuperscriptPlugin, c as BaseItalicPlugin, d as BaseHorizontalRulePlugin, f as BaseH1Plugin, g as BaseH5Plugin, h as BaseH4Plugin, i as BaseUnderlinePlugin, l as BaseCodePlugin, m as BaseH3Plugin, n as BaseHighlightPlugin, o as BaseSubscriptPlugin, p as BaseH2Plugin, r as BaseBasicMarksPlugin, s as BaseStrikethroughPlugin, t as BaseKbdPlugin, u as BaseBoldPlugin, v as BaseHeadingPlugin, y as BaseBlockquotePlugin } from "../BaseKbdPlugin-myd8t1-T.js";
import { Key, createPlatePlugin, toPlatePlugin } from "platejs/react";

//#region src/react/BlockquotePlugin.tsx
const BlockquotePlugin = toPlatePlugin(BaseBlockquotePlugin);

//#endregion
//#region src/react/HeadingPlugin.tsx
const HeadingPlugin = toPlatePlugin(BaseHeadingPlugin);
const H1Plugin = toPlatePlugin(BaseH1Plugin);
const H2Plugin = toPlatePlugin(BaseH2Plugin);
const H3Plugin = toPlatePlugin(BaseH3Plugin);
const H4Plugin = toPlatePlugin(BaseH4Plugin);
const H5Plugin = toPlatePlugin(BaseH5Plugin);
const H6Plugin = toPlatePlugin(BaseH6Plugin);

//#endregion
//#region src/react/HorizontalRulePlugin.tsx
const HorizontalRulePlugin = toPlatePlugin(BaseHorizontalRulePlugin);

//#endregion
//#region src/react/BasicBlocksPlugin.tsx
/**
* Enables support for basic elements:
*
* - Block quote
* - Code block
* - Heading
* - Paragraph
*/
const BasicBlocksPlugin = createPlatePlugin({ plugins: [
	BlockquotePlugin,
	HeadingPlugin,
	HorizontalRulePlugin
] });

//#endregion
//#region src/react/BoldPlugin.tsx
const BoldPlugin = toPlatePlugin(BaseBoldPlugin, { shortcuts: { toggle: { keys: [[Key.Mod, "b"]] } } });

//#endregion
//#region src/react/CodePlugin.tsx
const CodePlugin = toPlatePlugin(BaseCodePlugin);

//#endregion
//#region src/react/ItalicPlugin.tsx
const ItalicPlugin = toPlatePlugin(BaseItalicPlugin, { shortcuts: { toggle: { keys: [[Key.Mod, "i"]] } } });

//#endregion
//#region src/react/StrikethroughPlugin.tsx
const StrikethroughPlugin = toPlatePlugin(BaseStrikethroughPlugin);

//#endregion
//#region src/react/SubscriptPlugin.tsx
const SubscriptPlugin = toPlatePlugin(BaseSubscriptPlugin);

//#endregion
//#region src/react/SuperscriptPlugin.tsx
const SuperscriptPlugin = toPlatePlugin(BaseSuperscriptPlugin);

//#endregion
//#region src/react/UnderlinePlugin.tsx
const UnderlinePlugin = toPlatePlugin(BaseUnderlinePlugin, { shortcuts: { toggle: { keys: [[Key.Mod, "u"]] } } });

//#endregion
//#region src/react/BasicMarksPlugin.tsx
/**
* Enables support for basic marks:
*
* - Bold
* - Code
* - Italic
* - Strikethrough
* - Subscript
* - Superscript
* - Underline
*/
const BasicMarksPlugin = toPlatePlugin(BaseBasicMarksPlugin, { plugins: [
	BoldPlugin,
	CodePlugin,
	ItalicPlugin,
	StrikethroughPlugin,
	SubscriptPlugin,
	SuperscriptPlugin,
	UnderlinePlugin
] });

//#endregion
//#region src/react/HighlightPlugin.tsx
const HighlightPlugin = toPlatePlugin(BaseHighlightPlugin);

//#endregion
//#region src/react/KbdPlugin.tsx
/** Enables support for code formatting with React-specific features */
const KbdPlugin = toPlatePlugin(BaseKbdPlugin);

//#endregion
export { BasicBlocksPlugin, BasicMarksPlugin, BlockquotePlugin, BoldPlugin, CodePlugin, H1Plugin, H2Plugin, H3Plugin, H4Plugin, H5Plugin, H6Plugin, HeadingPlugin, HighlightPlugin, HorizontalRulePlugin, ItalicPlugin, KbdPlugin, StrikethroughPlugin, SubscriptPlugin, SuperscriptPlugin, UnderlinePlugin };